import type {FC, ReactElement} from 'react'
import {useSelector} from 'react-redux'
import {selectHasGuardedUnsavedChanges} from '@redux/selectors/customDashboardSelectors'
import UnsavedChangesDialog from '@shared/components/UnsavedChangesDialog'

const GlobalUnsavedChangesGuard: FC = (): ReactElement => {
  const hasUnsavedChanges = useSelector(selectHasGuardedUnsavedChanges)
  return <UnsavedChangesDialog hasUnsavedChanges={hasUnsavedChanges} />
}

export default GlobalUnsavedChangesGuard
